import { render, staticRenderFns } from "./qa-and-suggest.vue?vue&type=template&id=ee03a836&scoped=true&lang=pug&"
import script from "./qa-and-suggest.vue?vue&type=script&lang=js&"
export * from "./qa-and-suggest.vue?vue&type=script&lang=js&"
import style0 from "./qa-and-suggest.vue?vue&type=style&index=0&id=ee03a836&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee03a836",
  null
  
)

export default component.exports